<!-- <div class="loader-component">
    <div class="loader">
        <div class="loader__bar"></div>
        <div class="loader__bar"></div>
        <div class="loader__bar"></div>
        <div class="loader__bar"></div>
        <div class="loader__bar"></div>
        <div class="loader__ball"></div>
    </div>
</div> -->
<!-- <div class="loader-component">
    <div class="lds-ring" [ngStyle]="{  width:width, height:width}">
        <div [ngStyle]="{borderWidth:thickes}"></div>
        <div [ngStyle]="{borderWidth:thickes}"></div>
        <div [ngStyle]="{borderWidth:thickes}"></div>
        <div [ngStyle]="{borderWidth:thickes}"></div>
    </div>
</div> -->
<div class="loader-component">
    <div class="lds-ring {{class}}">
        <div ></div>
        <div ></div>
        <div ></div>
        <div ></div>
    </div>
</div>